import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { BottomNav } from './BottomNav';
import { DesktopSidebar } from './DesktopSidebar';
import { Topbar } from './Topbar';
import { FabMenu, FabMenuProvider } from './components/FabMenu';
import { getNavItem } from './navigation';
import { ToolOnboardingProvider } from '@shared/onboarding';
import { isOnboardingResolved } from '@modules/onboarding';
import { SmartAlertBanner, OfflineIndicator } from '@shared/ui';
import { useProfile } from '@shared/state';
import { track } from '@shared/events';

function FirstRunRedirect() {
  const profile = useProfile();
  const location = useLocation();
  // LOT 2 : `isOnboardingResolved()` couvre "completed" ET "deferred" — un
  // onboarding différé ("Plus tard") ne doit plus jamais reforcer la
  // redirection (Phase E : ne pas bloquer l'application si différé).
  const isFirstRun =
    !profile?.firstName &&
    !profile?.company &&
    !isOnboardingResolved() &&
    new URLSearchParams(window.location.search).get('demo') !== '1';
  if (!isFirstRun) return null;
  if (location.pathname.startsWith('/onboarding')) return null;
  return <Navigate to="/onboarding" replace />;
}

export function AppLayout() {
  const profile = useProfile();
  const location = useLocation();
  const mode = profile.mode || 'guided';

  useEffect(() => {
    if (!location.pathname.startsWith('/tools/')) return;
    const item = getNavItem(location.pathname);
    const slug = location.pathname.replace(/^\/tools\//, '').replace(/[^a-z0-9]+/gi, '_');
    track('tool_opened', {
      featureKey: `tool_${slug}`,
      metadata: { path: location.pathname, label: item?.label ?? null },
    });
  }, [location.pathname]);

  return (
    <ToolOnboardingProvider>
      <FabMenuProvider>
        <FirstRunRedirect />
        <OfflineIndicator />
        <SmartAlertBanner />
        <div className={`app-shell app-shell--${mode}`}>
          <DesktopSidebar />
          <div className="app-right">
            <Topbar />
            <main className="app-main">
              <Outlet />
            </main>
          </div>
          <BottomNav />
          <FabMenu />
        </div>
      </FabMenuProvider>
    </ToolOnboardingProvider>
  );
}
